module.exports = __webpack_public_path__ + "img/finland-ovarian-cancer-female.2001d064.png";